import { getAllCompositeSegments } from '@goldcast/player-config/src/utils/clipUtils';
import { Clip } from '@goldcast/player-config/src/types/clip-types';
import { ClipDeletes } from '@goldcast/player-config/src/types/RemotionPlayerConfigTypes/Segment/CompositeSegment';
import { roundToNDecimalPlaces } from '@goldcast/player-config/src/utils/mathUtils';
import { mergeDeletes } from '@goldcast/player-config/src/utils/assetMetadataUtils';
import { AddCompositeSegmentDeleteAction, AddCompositeSegmentDeleteWordsAction } from './types';

export const getClipCompositeSegment = (newClip: Clip) => {
  const allCompositeSegments = getAllCompositeSegments(newClip);

  if (allCompositeSegments.length === 0) {
    throw new Error('No composite segment found');
  }
  return allCompositeSegments[0];
};

export const addCompositeSegmentDelete = (
  clip: Clip,
  updateClipPayload: AddCompositeSegmentDeleteAction | AddCompositeSegmentDeleteWordsAction
) => {
  const { startTime, endTime } = updateClipPayload;
  const absoluteStartTime = roundToNDecimalPlaces(Math.min(startTime, endTime), 3, 'floor');
  const absoluteEndTime = roundToNDecimalPlaces(Math.max(startTime, endTime), 3, 'ceil');

  const newDeletes: ClipDeletes = {
    ...(clip.asset_metadata.deletes || {}),
    [absoluteStartTime]: {
      bounds: [absoluteStartTime, absoluteEndTime],
      prev_end_time: absoluteStartTime,
      next_start_time: absoluteEndTime,
      deleteType: updateClipPayload.deleteType
    }
  };

  const mergeDeletesData = mergeDeletes(newDeletes);
  clip.asset_metadata.deletes = mergeDeletesData;

  if (absoluteStartTime <= clip.asset_metadata.start && absoluteEndTime >= clip.asset_metadata.start) {
    clip.asset_metadata.start = absoluteEndTime;
  }
  if (absoluteEndTime >= clip.asset_metadata.end && absoluteStartTime <= clip.asset_metadata.end) {
    clip.asset_metadata.end = absoluteStartTime;
  }
  return clip;
};
